import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrowup",
  "use": "icon-arrowup-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"icon-arrowup\"><path fill=\"#28A745\" d=\"m10.303 8.04-4.25 4.25c-1.285 1.285-1.927 1.927-1.97 2.48a1.5 1.5 0 0 0 .52 1.257c.421.36 1.33.36 3.147.36h8.5c1.818 0 2.726 0 3.147-.36a1.5 1.5 0 0 0 .521-1.258c-.043-.552-.686-1.194-1.97-2.48l-4.25-4.25c-.595-.593-.892-.89-1.234-1.001a1.5 1.5 0 0 0-.927 0c-.343.11-.64.408-1.234 1.002\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol